import React from 'react';
import { Table, Tag, Tooltip, Typography } from 'antd';
import { money, qty, ruDate, useFillHeight, WORK_STATE } from './shared';

const { Text } = Typography;

const WorksTable = ({ items, loading, selectable, selectedKeys, onSelect, height }) => {
    const [boxRef, fillHeight] = useFillHeight();
    const columns = [
        {
            title: 'Статус',
            dataIndex: 'state',
            width: 150,
            fixed: 'left',
            render: (v, r) => {
                const [title, color] = WORK_STATE[v] || [v, 'default'];
                if (v === 'closed') {
                    return (
                        <Tooltip title={`Акт №${r.closed?.act_number} за ${r.closed?.period}`}>
                            <Tag color={color}>{title}</Tag>
                        </Tooltip>
                    );
                }
                return <Tag color={color}>{title}</Tag>;
            }
        },
        {
            title: 'Причина',
            dataIndex: 'error_titles',
            width: 220,
            render: (v, r) => (
                <>
                    {r.state === 'closed' && <Text type="secondary">в акте №{r.closed?.act_number}</Text>}
                    {r.state !== 'closed' && (v || []).map(t => <Tag key={t} color="red" style={{ marginBottom: 2 }}>{t}</Tag>)}
                    {(r.warning_titles || []).map(t => <Tag key={t} color="orange" style={{ marginBottom: 2 }}>{t}</Tag>)}
                </>
            )
        },
        { title: 'Дата', dataIndex: 'done_date', width: 95, render: ruDate },
        { title: 'Регион', dataIndex: 'region', width: 140 },
        { title: 'Объект', dataIndex: 'object_number', width: 110 },
        { title: 'Адрес', dataIndex: 'object_address', width: 220, ellipsis: { showTitle: true } },
        {
            title: 'Заявка',
            dataIndex: 'request_number',
            width: 140,
            render: (v, r) => (
                <>
                    {v || '—'}
                    {r.external_id && !String(v || '').startsWith('CRM') && (
                        <div><Text type="secondary" style={{ fontSize: 11 }}>CRM {r.external_id}</Text></div>
                    )}
                </>
            )
        },
        { title: 'Вид', dataIndex: 'work_type', width: 90 },
        { title: 'Наименование работы', dataIndex: 'work_name', width: 300, ellipsis: { showTitle: true } },
        { title: 'Исполнитель', dataIndex: 'executor', width: 170 },
        { title: 'Субподрядчик', dataIndex: 'subcontractor_name', width: 160, render: v => v || <Text type="danger">не привязан</Text> },
        { title: 'Кол-во', dataIndex: 'quantity', width: 80, align: 'right', render: qty },
        { title: 'Цена', dataIndex: 'price', width: 100, align: 'right', render: money },
        { title: 'Сумма', dataIndex: 'amount', width: 110, align: 'right', render: money },
        {
            title: 'Подтверждение',
            dataIndex: 'confirm_basis',
            width: 150,
            render: (v, r) => (r.confirmed ? <Text type="success">{v}</Text> : <Text type="warning">нет</Text>)
        },
        { title: 'Источник', dataIndex: 'source', width: 80, render: v => (v === 'excel' ? 'Excel' : 'CRM') }
    ];

    return (
        <div ref={boxRef}>
        <Table
            size="small"
            rowKey="key"
            loading={loading}
            dataSource={items}
            columns={columns}
            scroll={{ x: 2400, y: height || fillHeight }}
            pagination={{ defaultPageSize: 100, pageSizeOptions: [50, 100, 200, 500], showSizeChanger: true, showTotal: t => `Всего: ${t}` }}
            rowSelection={selectable ? {
                selectedRowKeys: selectedKeys,
                onChange: onSelect,
                getCheckboxProps: r => ({ disabled: r.state !== 'ready' }),
                preserveSelectedRowKeys: true
            } : undefined}
        />
        </div>
    );
};

export default WorksTable;
